import { put, takeLatest } from 'redux-saga/effects'
import prepareRegistration from '../api/prepareTOTPRegistration'
import {
  prepareTOTPRegistrationSucceeded,
  prepareTOTPRegistrationFailed
} from '../../actions/setupMFATOTP'
import { PREPARE_TOTP_REGISTRATION } from '../../constants/action.types'
import executeSaga from './helpers/executeSaga'

export function* prepareTOTPRegistration({ request }) {
  yield executeSaga(
    request,
    null,
    ({ totp_registration_uri, totp_registration_token }) =>
      put(
        prepareTOTPRegistrationSucceeded({
          registrationData: {
            uri: totp_registration_uri,
            token: totp_registration_token
          }
        })
      ),
    error => put(prepareTOTPRegistrationFailed({ errorCode: error.message }))
  )
}

export default function*({ request } = { request: prepareRegistration }) {
  yield takeLatest(PREPARE_TOTP_REGISTRATION, prepareTOTPRegistration, {
    request
  })
}
